<form [formGroup]="form">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Feedback</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-12 text-center">
        <p i18n>How did we do?</p>
        <label>
          <fa-icon *ngIf="form.controls.rating.value >= 1" [icon]="fa.faStar" class="h1"></fa-icon>
          <fa-icon *ngIf="form.controls.rating.value < 1" [icon]="fr.faStar" class="h1"></fa-icon>
          <input type="radio" name="rating" value="1" formControlName="rating" class="d-none">
        </label>
        <label>
          <fa-icon *ngIf="form.controls.rating.value >= 2" [icon]="fa.faStar" class="h1"></fa-icon>
          <fa-icon *ngIf="form.controls.rating.value < 2" [icon]="fr.faStar" class="h1"></fa-icon>
          <input type="radio" name="rating" value="2" formControlName="rating" class="d-none">
        </label>
        <label>
          <fa-icon *ngIf="form.controls.rating.value >= 3" [icon]="fa.faStar" class="h1"></fa-icon>
          <fa-icon *ngIf="form.controls.rating.value < 3" [icon]="fr.faStar" class="h1"></fa-icon>
          <input type="radio" name="rating" value="3" formControlName="rating" class="d-none">
        </label>
        <label>
          <fa-icon *ngIf="form.controls.rating.value >= 4" [icon]="fa.faStar" class="h1"></fa-icon>
          <fa-icon *ngIf="form.controls.rating.value < 4" [icon]="fr.faStar" class="h1"></fa-icon>
          <input type="radio" name="rating" value="4" formControlName="rating" class="d-none">
        </label>
        <label>
          <fa-icon *ngIf="form.controls.rating.value >= 5" [icon]="fa.faStar" class="h1"></fa-icon>
          <fa-icon *ngIf="form.controls.rating.value < 5" [icon]="fr.faStar" class="h1"></fa-icon>
          <input type="radio" name="rating" value="5" formControlName="rating" class="d-none">
        </label>
      </div>
      <div class="col-md-12">
        <label for="feedback" i18n>Feedback</label>
        <textarea rows="5" id="feedback" class="form-control" formControlName="feedback"></textarea>
      </div>
      <div *ngIf="form.controls.rating.value && form.controls.rating.value < 3" class="col-md-12">
        <p i18n>We are sorry to hear that you did not like our service.</p>
        <p i18n>According to our terms and conditions you are entitled to a refund up to 30%.</p>
        <p i18n>Select the appropriate refund amount and provide an explanation of what went wrong.</p>
        <select class="form-select" formControlName="refund">
          <option [ngValue]="null" i18n>No refund</option>
          <option ngValue="5">5% ({{ shift.total_invoicable * 0.05 | currency }})</option>
          <option ngValue="10">10% ({{ shift.total_invoicable * 0.1 | currency }})</option>
          <option ngValue="20">20% ({{ shift.total_invoicable * 0.2 | currency }})</option>
          <option ngValue="30">30% ({{ shift.total_invoicable * 0.3 | currency }})</option>
        </select>
      </div>
      <div *ngIf="form.controls.rating.value && form.controls.rating.value > 3" class="col-md-12">
        <p i18n>We are happy to hear you liked our service.</p>
        <p i18n>Would you like to add a tip to the partner?</p>
        
        <select class="form-select" formControlName="bonus">
          <option [ngValue]="null" i18n>No tip</option>
          <option ngValue="5">5% ({{ shift.total_invoicable_salary * 0.05 | currency }})</option>
          <option ngValue="10">10% ({{ shift.total_invoicable_salary * 0.1 | currency }})</option>
          <option ngValue="15">15% ({{ shift.total_invoicable_salary * 0.15 | currency }})</option>
          <option ngValue="20">20% ({{ shift.total_invoicable_salary * 0.2 | currency }})</option>
        </select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" [disabled]="!form.controls.rating.value || (form.controls.refund.value && form.controls.feedback.value == '')" class="btn btn-primary" (click)="save()" i18n>Send feedback</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
  </div>
</form>